/**
 * Class that mimics a complex Enum. Used to define locales.
 */
export class LocaleDefinition {
  public static readonly German = new LocaleDefinition('Deutsch (German)', 'de', 'DE', 'de')
  public static readonly English = new LocaleDefinition('English', 'en', 'US', 'en')
  public static readonly Spanish = new LocaleDefinition('Espanol (Spanish)', 'es', 'ES', 'es')
  public static readonly French = new LocaleDefinition('Francais (French)', 'fr', 'FR', 'fr')
  public static readonly Japanese = new LocaleDefinition('日本語 (Japanese)', 'ja', 'JP', 'ja')
  public static readonly Korean = new LocaleDefinition('한국어 (Korean)', 'ko', 'KR', 'ko')
  public static readonly Portuguese = new LocaleDefinition(
    'Português (Portuguese)',
    'pt',
    'BR',
    'pt'
  )
  public static readonly ChineseSimplified = new LocaleDefinition(
    '中文 (Chinese Simplified)',
    'zh',
    'CN',
    'zhHans'
  )
  public static readonly ChineseTraditional = new LocaleDefinition(
    '中文 (Chinese Traditional)',
    'zh',
    'TW',
    'zhHant'
  )

  protected constructor(
    public readonly title: string,
    public readonly language: any,
    public readonly region: string,
    public readonly vuetify: string
  ) {
    this.code = `${language}-${region}`
  }

  public readonly code!: string

  public toString(): string {
    return this.code
  }
}
